import BottomBar from "./BottomBar.component";

export default BottomBar;
